import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

function Pdf() {
    const location = useLocation();
    const stream = location.state?.stream || null;

  // Function to convert base64 to Uint8Array
  const base64ToArrayBuffer = (base64) => {
    const binaryString = window.atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);

    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    return bytes;
  };

  // Create a blob from Uint8Array
  const pdfBlob = new Blob([base64ToArrayBuffer(stream)], { type: 'application/pdf' });
  const pdfUrl = useMemo(() => URL.createObjectURL(pdfBlob), [stream]);

  return (
    <div>
      <iframe title="PDF Viewer" src={pdfUrl} width="100%" height="850" />
    </div>
  );
}

export default Pdf;
